export const INSIDER_TRADING = "INSIDER_TRADING";
export const INSIDER_TRADING_ERROR = "INSIDER_TRADING_ERROR";
export const INSIDER_TRADING_HIDE_ERROR = "INSIDER_TRADING_HIDE_ERROR";
export const INSIDER_START_LOADER = "START_LOADER";
export const INSIDER_STOP_LOADER = "INSIDER_STOP_LOADER";
export const INSIDER_SORT = "INSIDER_SORT";
export const INSIDER_CLEAR_SORT = "INSIDER_CLEAR_SORT";
